// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueResource from 'vue-resource';
import Meta from 'vue-meta'
import App from './App'
import router from './router/index'
import VueFire from 'vuefire'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'
import store from './store';

Vue.config.productionTip = (process.env.NODE_ENV === 'production');

Vue.use(VueFire);
Vue.use(VueResource);
Vue.use(Meta);

let app;

firebase.initializeApp({
    apiKey: 'AIzaSyDdE4ed6OL6WfuB5fwoWf0zcNWkK4imXDw',
    authDomain: 'rating-page.firebaseapp.com',
    databaseURL: 'https://rating-page.firebaseio.com',
    projectId: 'rating-page',
    storageBucket: 'rating-page.appspot.com',
    messagingSenderId: '752787819050'
});

export const db = firebase.firestore();
export const storage = firebase.storage();

db.settings({timestampsInSnapshots: true});

firebase.auth().onAuthStateChanged(function (user) {
    /* eslint-disable no-new */
    if (!app) {
        app = new Vue({
            el: '#app',
            router,
            components: {App},
            template: '<App/>',
            beforeCreate: async function () {
                await store.fetchRssFeedAction();
                await firebase.auth().signInAnonymously();
                console.info('logged in');
            },
            data: {
                sharedState: store.state
            }
        });
    }
});



// WEBPACK FOOTER //
// ./src/main.js